// src/redux/slices/profile.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiProfileOut3 } from '@agunity/api-v4';
import { RootState } from '../store';
import { apiService } from '../../api/apiService';

export interface ProfileState {
  fullProfile: ApiProfileOut3 | null,
}

const initialState: ProfileState = {
  fullProfile: null,
};

export const fullProfileSlice = createSlice({
  name: 'fullProfile',
  initialState,
  reducers: {
    store: (
      state: ProfileState,
      action: PayloadAction<ProfileState>
    ) => {
      // Copy each property from the payload to the state
      Object.assign(state, action.payload);
    },
    clear: (
      state: ProfileState,
    ) => {
      // Set each property of the state back to its initial value
      Object.assign(state, initialState);
    }
  },
});

export const { store, clear } = fullProfileSlice.actions;

export const selectFullProfile = (state: RootState) => state.full.fullProfile;

export const fetchProfile =
  () =>
    async (
      dispatch: Function,
    ): Promise<ApiProfileOut3 | undefined> => {
      try {
        const response = (await apiService.profileV42FullList());
        if (response) {
          await dispatch(store({ fullProfile: response.data }));
        }
        return response.data;
      }catch (e) {
        console.log(e);
      }
    };

export const profileInit =
  () =>
    async (dispatch: Function, getState: Function): Promise<void> => {
      const profile = (getState() as  RootState).full?.fullProfile;
      if (!profile)
        await dispatch(fetchProfile());
    };

export default fullProfileSlice.reducer;
